import { useTracking } from '@justgiving/react-tracking';
import { useEffect } from 'react';

export interface PageViewTrackingProps {
  event: string;
  subtype: string;
  page_section: string;
}

export default function usePageViewTracking(
  pageViewTrackingProps?: PageViewTrackingProps,
) {
  const track = useTracking();

  useEffect(() => {
    if (pageViewTrackingProps) {
      track({ ...pageViewTrackingProps });
    }
  }, [pageViewTrackingProps, track]);
}
